import { Outlet } from "react-router-dom";
import { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { api } from "../lib/api";
import { useAuthStore } from "../store/auth-store";

export function AppShell() {
  const token = useAuthStore((s) => s.token);
  const companyName = useAuthStore((s) => s.companyName);
  const login = useAuthStore((s) => s.login);

  // Osveži podatke o korisniku (rola, isSuperAdmin, aktivnost) pri svakom
  // učitavanju aplikacije - ne samo pri prijavi. Bez ovoga, promene role
  // ili super-admin statusa na serveru se ne bi videle dok se korisnik
  // ručno ne odjavi i ponovo prijavi.
  const { data: me } = useQuery({
    queryKey: ["me"],
    queryFn: () => api.getMe(),
    enabled: !!token,
    staleTime: 0,
  });

  useEffect(() => {
    if (me && token) {
      login(token, me, companyName ?? "");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [me]);

  return (
    <div className="flex h-screen w-screen overflow-hidden bg-app-bg text-slate-800">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        <TopBar />
        {/* min-h-0 (24.09.2026, root-cause za "cela strana ima skrol" na
            kasi) - flex stavke po default-u imaju min-height: auto, što
            znači da njihova "automatska minimalna veličina" (određena
            sadržajem) može da nadjača visinu izračunatu flex-om i time
            poništi efekat overflow-auto - sadržaj (npr. POS mreža sa
            h-full) bi se onda raširio na punu visinu SVOG sadržaja umesto
            da bude ograničen na vidljivi deo ekrana, i to bi gurnulo celu
            stranicu u skrol. min-h-0 je standardno rešenje za ovaj poznati
            flexbox problem. */}
        <main className="min-h-0 flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
